import { css, type Theme } from '@emotion/react';
import { usePodInfoState } from 'client/state/PodInfoState';
import { Dialog } from 'client/components/Dialog/Dialog';
import { PodInfoDialogContents } from 'client/components/Dialog/PodInfoDialogContents';
import { Typography } from 'client/components/Typography/Typography';

export const PodInfoDialog = () => {
  const { dialog, hideDialog, data } = usePodInfoState();
  const { open, fullscreen } = dialog;

  let contents: React.ReactElement;
  if (data.status == 'ok') {
    contents = <pre>{JSON.stringify(data, null, 2)}</pre>;
  } else {
    contents = <div>ERROR</div>;
  }
  return (
    <Dialog
      open={open}
      icon={null}
      title={'Describe Pod'}
      hideHeader={false}
      description={'Advanced information about the component pod kubernetes configuration. Especially useful for component developers.'}
      primaryAction={null}
      secondaryAction={null}
      width={1400}
      fullscreen={fullscreen}
      headerActions={undefined}
      onClose={hideDialog}
      css={[dialogStyle, fullscreen && fullscreenDialogStyle]}
    >
      <Typography>
        {data.status == 'ok' && <PodInfoDialogContents data={data} />}
        {data.status != 'ok' && <div>Error {data.status}</div>}
      </Typography>
    </Dialog>
  );
};

const dialogStyle = (theme: Theme) => css`
  > .MuiDialog-container > .MuiPaper-root {
    padding: 0;
    height: calc(100vh - 2rem);
    background-color: ${theme.color.black};

    > .MuiListItem-root {
      padding: calc(16px + 8px) calc(24px + 8px);
    }

    .MuiListItemSecondaryAction-root {
      > button,
      > a {
        position: relative;
      }
    }

    .MuiListItemSecondaryAction-root > button > span {
      color: ${theme.color.white};
    }

    .MuiListItemSecondaryAction-root > a > button > span {
      color: ${theme.color.white};
    }
  }

  .MuiDialogContent-root {
    padding: 0px 32px 24px 32px;
  }

  .typography {
    color: ${theme.color.white};
  }
`;

const fullscreenDialogStyle = css`
  > .MuiDialog-container > .MuiPaper-root {
    height: 100vh;
  }
`;
